import { IonContent, IonPage } from '@ionic/react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { checkForUpdatesOnLoginScreen } from '../../../../serviceWorkerRegistration';
import CasinoNavBar from 'components/CasinoNavBar';
import { SignInAccount } from './SignInAccount';

export const Login = () => {
  const history = useHistory();

  useEffect(() => {
    checkForUpdatesOnLoginScreen();
  }, []);

  return (
    <IonPage className="login-v2-page">
      <IonContent fullscreen>
        <div className="login-v2-wrapper">
          <div className="casino-fixed-top__nav login-v2-nav-wrap">
            <CasinoNavBar hideSearch hideLogo hideMenu isDarkMode />
            <button
              className="login-v2-back-btn"
              onClick={() => history.goBack()}
              aria-label="Go back"
            />
          </div>
          <div className="login-v2-bg">
            <div className="login-v2-body">
              <h1 className="login-v2-welcome">WELCOME</h1>
              <SignInAccount />
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};
